<template>
    <div>
        <select v-if="settings.enable_ach || billingProfile"
                v-model="form.type"
                @change="$emit('clear-error')"
                id="payment_method"
                name="payment_method"
                :class="`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 mt-1 block w-full pl-4 pr-10 py-3 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md`">
            <option :value="null">Choose Method:</option>
            <option value="same" v-if="billingProfile && billingProfile.payment_type">
                {{ billingProfile.payment_type === 'check' ? 'Checking' : billingProfile.card_type }} •••• {{ billingProfile.account_last_4 ?? billingProfile.account_last_four }}
            </option>
            <option v-if="settings.enable_ach" value="check">Pay with Personal Bank account</option>
            <option value="card">Pay with Credit/Debit Card</option>
        </select>

        <pay-with-bank v-if="settings.enable_ach && form.type === 'check'"
            :first_name.sync="form.first_name"
            :last_name.sync="form.last_name"
            :address.sync="form.address"
            :city.sync="form.city"
            :state.sync="form.state"
            :routing_number.sync="form.routing_number"
            :account_number.sync="form.account_number"
            :error="error" class="mt-4"
            :states="states"
            :settings="settings"/>

        <pay-with-card v-else-if="form.type === 'card'"
            :first_name.sync="form.first_name"
            :last_name.sync="form.last_name"
            :address.sync="form.address"
            :city.sync="form.city"
            :state.sync="form.state"
            :cc_number.sync="form.cc_number"
            :card_exp.sync="form.card_exp"
            :cvv.sync="form.cvv"
            :zip.sync="form.zip"
            :error="error" class="mt-4"
            :states="states"
            :settings="settings"
            :cc-valid-status="ccValidStatus"/>
    </div>
</template>

<script>
    import PayWithCard from '../../../components/PaymentMethods/PayWithCard.vue'
    import PayWithBank from '../../../components/PaymentMethods/PayWithBank.vue'

    export default {
        props: {
            billingProfile: Object,
            settings: Object,
            form: Object,
            error: String,
        },

        components: {
            PayWithCard,
            PayWithBank,
        },

        watch: {
            'form.type'(type, oldType) {
                if (type === 'same') {
                    this.form.billing_profile_id = this.billingProfile.id;
                } else {
                    this.form.billing_profile_id = null;
                }
            }
        },

        computed: {
            states() {
                return this.$root.states;
            },

            ccValidStatus() {
                if (/[^0-9-\s]+/.test(this.form.cc_number)) return false;

                // The Luhn Algorithm. It's so pretty.
                var nCheck = 0,
                    nDigit = 0,
                    bEven = false;

                let value = this.form.cc_number.replace(/\D/g, "");

                for (var n = value.length - 1; n >= 0; n--) {
                    var cDigit = value.charAt(n),
                        nDigit = parseInt(cDigit, 10);

                    if (bEven) {
                        if ((nDigit *= 2) > 9) nDigit -= 9;
                    }

                    nCheck += nDigit;
                    bEven = !bEven;
                }

                return (nCheck % 10) == 0;
            },
        }
    }
</script>
